<template>
  <div class="login-page">
    <Header :isLogin="true" />
    <section class="login-wrap">
      <div class="login-content">
        <el-form
          :model="param"
          :rules="rules"
          ref="login"
          label-width="0px"
          class="ms-content"
        >
          <section class="login-info">
            <p class="title">登录</p>
            <el-form-item prop="username">
              <el-input
                type="text"
                class="mb-10"
                v-model="param.username"
                placeholder="请输入用户名"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                class="mb-20"
                v-model="param.password"
                placeholder="请输入密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-button
              class="w-100 mb-10 login-btn"
              type="primary"
              @click="submitForm()"
              :loading="loading"
              >登录
            </el-button>
            <div class="handle-wrap">
              <span class="portal">使用 Portal 用户名和密码登录</span>
              <el-checkbox v-model="autoLogin">记住密码</el-checkbox>
            </div>
          </section>
        </el-form>
      </div>
    </section>
    <footer>
      <p class="first-line">
        版权所有：中国电子商会物联网技术产品应用专业委员会
        技术支持：山东国发信航信息技术有限公司 京ICP备12033619
      </p>
      <p class="second-line">
        <span>“海尔合规热线”：</span>
        <span>www.haierchina.ethicspoint.com</span>
      </p>
    </footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import VueCookie from "../config/util.cookies";
export default {
  components: {
    Header
  },
  data() {
    return {
      loading: false,
      param: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      autoLogin: true
    };
  },
  methods: {
    submitForm() {
      let _this = this;
      _this.loading = true;
      _this.$refs["login"].validate(valid => {
        _this.loading = false;
        if (valid) {
          let param = {
            url: "/api/user/login",
            params: {
              username: _this.param.username,
              password: _this.param.password
            }
          };
          _this.$store.dispatch("login", param).then(() => {
            _this.$router.push("/dashboard/home");
            _this.$message({
              type: "success",
              message: "登录成功",
              duration: 3000
            });
          });
        } else {
          _this.$message({
            type: "error",
            message: "请完善登录信息",
            duration: 3000
          });
        }
      });
    }
  }
};
</script>
<style lang="sass" scoped>
.login-page
  display: flex
  flex-direction: column
  min-height: 100vh
  overflow: hidden
  .login-wrap
    width: 100%
    background: url('../assets/images/login.jpg') no-repeat center
    background-size: cover
    .login-content
      position: relative
      width: 1200px
      height: 460px
      margin: 0 auto
    .login-info
      position: absolute
      right: 10px
      top: 50%
      transform: translateY(-50%)
      width: 400px
      box-sizing: border-box
      padding: 30px
      border-radius: 5px
      background-color: rgba(255, 255, 255, .7)
      .title
        font-size: 18px
        margin-bottom: 15px
      .login-btn
        width: 50%
      .handle-wrap
        display: flex
        justify-content: space-between
        flex-direction: column
        .portal
          font-size: 14px
          color: #409eff
          cursor: pointer

  footer
    flex: 1
    width: 100vw
    background: rgb(225, 225, 225)
    .first-line, .second-line
      text-align: center
      font-size: 14px
    .first-line
      padding-top: 100px
      color: rgb(149, 149, 149)
      margin-bottom: 5px
    .second-line
      &>span:first-child
        color: rgb(149, 149, 149)
      &>span:last-child
        color: #000
</style>
